<template>
  <v-container v-if="dateResourse!=undefined">
    <v-row>
      {{ $t("onlineForm.setPersonalData.confirm", {date: localeDate, minutes: longTime, filial: (currentFilial&&steps.length==3?'. '+currentFilial.name:'')}) }}
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="290">       
        <v-card>
          <v-card-title class="headline">{{ $t("onlineForm.setPersonalData.successTitle") }}</v-card-title>
          <v-card-text>
            {{ $t("onlineForm.setPersonalData.successSubtitle", {date: localeDate, minutes: longTime, filial: (currentFilial&&steps.length==3?'. '+currentFilial.name:'')}) }}
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-row justify="center" no-gutters>
              <v-btn text color="success" @click="startNew">
                {{ $t("onlineForm.setPersonalData.successMore") }}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-row class="mt-3">
      <v-text-field
        ref='phone'
        class="numberIcon" 
        :label="$t('onlineForm.setPersonalData.phone')"
        v-model="phone"
        @input="rulesPhone"
        :item-color="vidgetOptions.colorField.hex"
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        :color="vidgetOptions.colorField.hex"   
        :rules="[rules.length, rules.lengthPhone, rules.testPhone]"
      >
          <template v-if="currPrefix" v-slot:prepend-inner>
               
              <v-menu offset-y min-width="300px" max-height="300px">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" :style="'background: url('+flagImg24+'); margin-right: 5px; width: 24px; height: 24px; background-position: 0 '+(currPrefix.position==0?0:currPrefix.position/16*24)+'px;'"></div>
                </template>
                <v-list>
                  <v-list-item @click="currPrefix=phonePrefix" v-for="(phonePrefix, idxPrefix) in prefixToList" :key="idxPrefix">
                    <v-list-item-title>
                      <v-row no-gutters>
                        <div :style="'background: url('+flagImg24+'); margin-right: 5px; width: 24px; height: 24px; background-position: 0 '+(phonePrefix.position==0?0:phonePrefix.position/16*24)+'px;'"></div>
                        {{phonePrefix.name}}
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-label> {{currPrefix.prefix}}</v-label>
          </template>
      </v-text-field>
    </v-row>

    <v-row>
      <v-text-field
        ref='lastName'
        :label="$t('onlineForm.setPersonalData.lastName')"
        v-model="lastName"
        :item-color="vidgetOptions.colorField.hex"
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        :rules="[rules.length]"
        :color="vidgetOptions.colorField.hex"
      >
      </v-text-field>
    </v-row>

    <v-row>
      <v-text-field
        :label="$t('onlineForm.setPersonalData.name')"
        v-model="name"
        ref='name'
        :item-color="vidgetOptions.colorField.hex"
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        :rules="[rules.length]"
        :color="vidgetOptions.colorField.hex"
      >
      </v-text-field>
    </v-row>

    <v-row>
      <v-text-field
        :label="$t('onlineForm.setPersonalData.secondName')"
        v-model="secondName"
        ref='secondName'
        :item-color="vidgetOptions.colorField.hex"
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        :color="vidgetOptions.colorField.hex"
      >
      </v-text-field>
    </v-row>

    <v-row v-for="(field, keyField) in vidgetOptions.fields" :key="keyField">
      <v-text-field
        :label="field.label"
        :hint="field.text"
        v-model="field.value"
        :item-color="vidgetOptions.colorField.hex"
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        :color="vidgetOptions.colorField.hex"
      >
      </v-text-field>
    </v-row>

    <v-row class="mt-6" justify="center">
      <v-btn
        :color="vidgetOptions.colorField.hex"
        @click="submit"
        :disabled="!buttonActive"
      >
        {{ $t("onlineForm.setPersonalData.submit") }}
      </v-btn>
    </v-row>
      
  </v-container>
</template>

<script>
  import {mask} from 'vue-the-mask';
  import axios from 'axios';
  export default {
    directives: {mask},
    name: 'StepPersonalData',

    methods:{
      rulesPhone:function(){
        if (this.phone[0]=="8"&&this.currPrefix.value=="ru"){
          this.phone=this.phone.substr(1);
        }
      },
      startNew:function(){
        this.dialog=false;
        setTimeout(() => {
          this.$emit('startNew');
        }, 100);
        // 
      },

      submit:function(){
        var refs=this.$refs;
        this.$emit('update:localLoading', true);
        this.buttonActive=false;
        for (let idx in refs){
          if (refs[idx].validate!=undefined){
            if (!refs[idx].validate(true)){
              this.$emit('update:localLoading', false);
              this.buttonActive=true;
              return;
            }
          }
        }

        var values={};
        for (let idx in this.vidgetOptions.fields){
          values[this.vidgetOptions.fields[idx].name]=this.vidgetOptions.fields[idx].value;
        }
    
        values.PHONE=this.currPrefix.prefix+this.phone;
        values.NAME=this.name;
        values.LAST_NAME=this.lastName;
        values.SECOND_NAME=this.secondName;

        // Заполняем утмки
        if (this.utmObject){
          if (this.utmObject.utm_campaign){
            values.UTM_CAMPAIGN=this.utmObject.utm_campaign;
          }
          if (this.utmObject.utm_content){
            values.UTM_CONTENT=this.utmObject.utm_content;
          }
          if (this.utmObject.utm_medium){
            values.UTM_MEDIUM=this.utmObject.utm_medium;
          }
          if (this.utmObject.utm_source){
            values.UTM_SOURCE=this.utmObject.utm_source;
          }
          if (this.utmObject.utm_term){
            values.UTM_TERM=this.utmObject.utm_term;
          }
        }

        var propsAxios={
          fields:values,
          filial:this.currentFilial&&this.currentFilial.id?this.currentFilial.id:"",
          group:this.currNapr.value,
          entity:this.dateResourse.entity,
          date:new Date(Number(this.dateResourse.time)-this.timezoneOffset*1000).toISOString(),
          dateStart:new Date(Date.parse(new Date(Number(this.dateResourse.time)-1000).toISOString().replace(/(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+).\d+Z/, '$1-$2-$3 $4:$5:$6'))).toLocaleString('ru-RU').replace(",",  ""),
          dateEnd:new Date(Date.parse(new Date(Number(this.dateResourse.time)+(this.longTime)*60*1000).toISOString().replace(/(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+).\d+Z/, '$1-$2-$3 $4:$5:$6'))).toLocaleString('ru-RU').replace(",",  ""),
          arrProduct:this.arrProduct,
          tokenForm:this.formToken,
          longTime:this.longTime,
          action:'createLead'
        };

        axios.post('https://crm.mywebstor.com/local/webhooks/calendar/indexv4.php', propsAxios)
            .then((response)=>{   
                if (response.data.status=="success"){
                  this.$root.$emit('sendEventYandexGoogle', "myWebStor_successSendForm");
                  top.postMessage('eventCloseWebstorFrame', "*");
                  this.dialog=true;
                }
                else{
                  this.$root.$emit('sendEventYandexGoogle', "myWebStor_errorSendForm");
                  this.$root.$emit('showSnackBar', {text:response.data.message, show:true}); 
                }
                this.$emit('update:localLoading', false);
                this.buttonActive=true;
            })
            .catch((error)=>{
              this.$root.$emit('sendEventYandexGoogle', "myWebStor_errorSendForm");
              this.$root.$emit('showSnackBar', {text:error, show:true}); 
              this.$emit('update:localLoading', false);
              this.buttonActive=true;
            });        
      },
      currPrefixFill:function(){
        if (!this.phone.indexOf){
          let defPrefix=this.numbersPrefix.find(el=>{return el.value==this.vidgetOptions.defaultPrefix});
          this.currPrefix=defPrefix;
          return;
        }
        for (let idx in this.prefixToList){
          if(this.phone.indexOf(this.prefixToList[idx].prefix)==0){
            this.currPrefix=this.prefixToList[idx];
            return;
          }
        }
        if (!this.currPrefix){
          if (this.vidgetOptions.defaultPrefix){
            let defPrefix=this.prefixToList.find(el=>{return el.value==this.vidgetOptions.defaultPrefix});
            this.currPrefix=defPrefix;
          }
          else{
            this.currPrefix=this.prefixToList[0];
          }
        }
      }
    }, 

    computed:{
      prefixToList:function(){
        let result=[];
        if (this.vidgetOptions.selectedNumberPrefix){
          for (let idx in this.numbersPrefix){
            if (this.vidgetOptions.selectedNumberPrefix.indexOf(this.numbersPrefix[idx].value)!=-1){
              result.push(this.numbersPrefix[idx]);
            }
          }
        }
        else{
          return [this.numbersPrefix[0]];
        }
        return result;
      },
      localeDate:function(){
        if (this.dateResourse==undefined||isNaN(Number(this.dateResourse.time))){
          return "";
        }
        return new Date(Number(this.dateResourse.time)+new Date().getTimezoneOffset()*60*1000).toLocaleString();
      },
      rules:function(){
        return {
          length: value=>{
            return value.length>0||this.$t("errors.field_not_filled");
          },
          lengthPhone: value=>{
            return value.length<21||this.$t("errors.invalid_phone_length");
          },
          testPhone: value=>{
            return value.match(/[^\d]/)==null||value.length<5&&value[0]=="+"||this.$t("errors.invalid_phone_symbols");
          }
        };
      }
    },

    props:{
      vidgetOptions:undefined,
      currStep:undefined,
      currentFilial:undefined,
      steps:undefined,
      formToken:undefined,
      appOptions:undefined,
      localLoading:undefined,
      dateResourse:undefined,
      longTime:undefined,
      arrProduct:undefined,
      utmObject:undefined,
      currNapr:undefined,
      timezoneOffset:undefined,
    },

    components:{

    },

    watch:{
      phone:function(){
        this.currPrefixFill();
      },
      currPrefix:function(){
        this.phone=this.phone.replace(this.currPrefix.prefix,"");
      },
      currStep:function(){
        this.currPrefixFill();
        if (this.steps[this.currStep-1].value=='inputPersonalData'){
          this.$root.$emit('sendEventYandexGoogle', "myWebStor_stepInputPersonalData");
        }
      }
    },

    data: () => ({
        currPrefix:undefined,
        flagImg16:require("../assets/sprite-16.png"),
        flagImg24:require("../assets/sprite-24.png"),
        numbersPrefix:[{"value":"ru","name":"Ru (+7)","position":"-2960","prefix":"+7"},{"value":"az","name":"Az (+994)","position":"-256","prefix":"+994"},{"value":"am","name":"Am (+374)","position":"-96","prefix":"+374"},{"value":"by","name":"By (+375)","position":"-544","prefix":"+375"},{"value":"ge","name":"Ge (+995)","position":"-1248","prefix":"+995"},{"value":"kz","name":"Kz (+7)","position":"-1936","prefix":"+7"},{"value":"kg","name":"Kg (+996)","position":"-1792","prefix":"+996"},{"value":"lv","name":"Lv (+371)","position":"-2096","prefix":"+371"},{"value":"lt","name":"Lt (+370)","position":"-2064","prefix":"+370"},{"value":"md","name":"Md (+373)","position":"-2160","prefix":"+373"},{"value":"tj","name":"Tj (+992)","position":"-3376","prefix":"+992"},{"value":"tm","name":"Tm (+993)","position":"-3424","prefix":"+993"},{"value":"uz","name":"Uz (+998)","position":"-3616","prefix":"+998"},{"value":"ua","name":"Ua (+380)","position":"-3552","prefix":"+380"},{"value":"ee","name":"Ee (+372)","position":"-992","prefix":"+372"},{"value":"au","name":"Au (+61)","position":"-208","prefix":"+61"},{"value":"at","name":"At (+43)","position":"-192","prefix":"+43"},{"value":"al","name":"Al (+355)","position":"-80","prefix":"+355"},{"value":"dz","name":"Dz (+213)","position":"-960","prefix":"+213"},{"value":"ao","name":"Ao (+244)","position":"-128","prefix":"+244"},{"value":"ar","name":"Ar (+54)","position":"-160","prefix":"+54"},{"value":"aw","name":"Aw (+297)","position":"-224","prefix":"+297"},{"value":"af","name":"Af (+93)","position":"-32","prefix":"+93"},{"value":"bd","name":"Bd (+880)","position":"-304","prefix":"+880"},{"value":"bb","name":"Bb (+1)","position":"-288","prefix":"+1"},{"value":"be","name":"Be (+32)","position":"-320","prefix":"+32"},{"value":"bj","name":"Bj (+229)","position":"-400","prefix":"+229"},{"value":"bg","name":"Bg (+359)","position":"-352","prefix":"+359"},{"value":"bo","name":"Bo (+591)","position":"-464","prefix":"+591"},{"value":"br","name":"Br (+55)","position":"-480","prefix":"+55"},{"value":"bn","name":"Bn (+673)","position":"-448","prefix":"+673"},{"value":"gb","name":"Gb (+44)","position":"-1216","prefix":"+44"},{"value":"hu","name":"Hu (+36)","position":"-1536","prefix":"+36"},{"value":"ve","name":"Ve (+58)","position":"-3664","prefix":"+58"},{"value":"vn","name":"Vn (+84)","position":"-3712","prefix":"+84"},{"value":"ht","name":"Ht (+509)","position":"-1520","prefix":"+509"},{"value":"gm","name":"Gm (+220)","position":"-1328","prefix":"+220"},{"value":"hn","name":"Hn (+504)","position":"-1488","prefix":"+504"},{"value":"gp","name":"Gp (+590)","position":"","prefix":"+590"},{"value":"gt","name":"Gt (+502)","position":"-1408","prefix":"+502"},{"value":"gn","name":"Gn (+224)","position":"-1344","prefix":"+224"},{"value":"de","name":"De (+49)","position":"-880","prefix":"+49"},{"value":"gi","name":"Gi (+350)","position":"-1296","prefix":"+350"},{"value":"nl","name":"Nl (+31)","position":"-2592","prefix":"+31"},{"value":"hk","name":"Hk (+852)","position":"-1472","prefix":"+852"},{"value":"gd","name":"Gd (+1)","position":"-1232","prefix":"+1"},{"value":"gl","name":"Gl (+299)","position":"-1312","prefix":"+299"},{"value":"gr","name":"Gr (+30)","position":"-1376","prefix":"+30"},{"value":"gy","name":"Gy (+592)","position":"-1456","prefix":"+592"},{"value":"dk","name":"Dk (+45)","position":"-912","prefix":"+45"},{"value":"eg","name":"Eg (+20)","position":"-1008","prefix":"+20"},{"value":"zm","name":"Zm (+260)","position":"-3824","prefix":"+260"},{"value":"zw","name":"Zw (+263)","position":"-3840","prefix":"+263"},{"value":"il","name":"Il (+972)","position":"-1600","prefix":"+972"},{"value":"in","name":"In (+91)","position":"-1632","prefix":"+91"},{"value":"id","name":"Id (+62)","position":"-1568","prefix":"+62"},{"value":"jo","name":"Jo (+962)","position":"-1744","prefix":"+962"},{"value":"iq","name":"Iq (+964)","position":"-1648","prefix":"+964"},{"value":"ir","name":"Ir (+98)","position":"-1664","prefix":"+98"},{"value":"ie","name":"Ie (+353)","position":"-1584","prefix":"+353"},{"value":"is","name":"Is (+354)","position":"-1680","prefix":"+354"},{"value":"es","name":"Es (+34)","position":"-1056","prefix":"+34"},{"value":"it","name":"It (+39)","position":"-1696","prefix":"+39"},{"value":"ye","name":"Ye (+967)","position":"-3776","prefix":"+967"},{"value":"cm","name":"Cm (+237)","position":"-720","prefix":"+237"},{"value":"ca","name":"Ca (+1)","position":"-576","prefix":"+1"},{"value":"ke","name":"Ke (+254)","position":"-1776","prefix":"+254"},{"value":"cy","name":"Cy (+357)","position":"-848","prefix":"+357"},{"value":"cn","name":"Cn (+86)","position":"-736","prefix":"+86"},{"value":"co","name":"Co (+57)","position":"-752","prefix":"+57"},{"value":"kh","name":"Kh (+855)","position":"-1808","prefix":"+855"},{"value":"cg","name":"Cg (+242)","position":"-640","prefix":"+242"},{"value":"kr","name":"Kr (Южная)","position":"-1888","prefix":"Южная"},{"value":"cu","name":"Cu (+53)","position":"-784","prefix":"+53"},{"value":"kw","name":"Kw (+965)","position":"-1904","prefix":"+965"},{"value":"lr","name":"Lr (+231)","position":"-2032","prefix":"+231"},{"value":"li","name":"Li (+423)","position":"-2000","prefix":"+423"},{"value":"lu","name":"Lu (+352)","position":"-2080","prefix":"+352"},{"value":"mr","name":"Mr (+222)","position":"-2352","prefix":"+222"},{"value":"mg","name":"Mg (+261)","position":"-2208","prefix":"+261"},{"value":"mk","name":"Mk (+389)","position":"-2240","prefix":"+389"},{"value":"my","name":"My (+60)","position":"-2464","prefix":"+60"},{"value":"ml","name":"Ml (+223)","position":"-2256","prefix":"+223"},{"value":"mt","name":"Mt (+356)","position":"-2384","prefix":"+356"},{"value":"mx","name":"Mx (+52)","position":"-2448","prefix":"+52"},{"value":"mz","name":"Mz (+258)","position":"-2480","prefix":"+258"},{"value":"mc","name":"Mc (+377)","position":"-2144","prefix":"+377"},{"value":"mn","name":"Mn (+976)","position":"-2288","prefix":"+976"},{"value":"ma","name":"Ma (+212)","position":"-2128","prefix":"+212"},{"value":"na","name":"Na (+264)","position":"-2496","prefix":"+264"},{"value":"np","name":"Np (+977)","position":"-2624","prefix":"+977"},{"value":"ng","name":"Ng (+234)","position":"-2560","prefix":"+234"},{"value":"ni","name":"Ni (+505)","position":"-2576","prefix":"+505"},{"value":"no","name":"No (+47)","position":"-2608","prefix":"+47"},{"value":"pk","name":"Pk (+92)","position":"-2784","prefix":"+92"},{"value":"pa","name":"Pa (+507)","position":"-2704","prefix":"+507"},{"value":"py","name":"Py (+595)","position":"-2896","prefix":"+595"},{"value":"pe","name":"Pe (+51)","position":"-2720","prefix":"+51"},{"value":"pl","name":"Pl (+48)","position":"-2800","prefix":"+48"},{"value":"pt","name":"Pt (+351)","position":"-2864","prefix":"+351"},{"value":"ro","name":"Ro (+40)","position":"-2928","prefix":"+40"},{"value":"sn","name":"Sn (+221)","position":"-3168","prefix":"+221"},{"value":"sg","name":"Sg (+65)","position":"-3072","prefix":"+65"},{"value":"sy","name":"Sy (+963)","position":"-3264","prefix":"+963"},{"value":"sk","name":"Sk (+421)","position":"-3120","prefix":"+421"},{"value":"si","name":"Si (+386)","position":"-3104","prefix":"+386"},{"value":"so","name":"So (+252)","position":"-3184","prefix":"+252"},{"value":"sd","name":"Sd (+249)","position":"-3040","prefix":"+249"},{"value":"us","name":"Us (+1)","position":"-3584","prefix":"+1"},{"value":"tw","name":"Tw (+886)","position":"-3520","prefix":"+886"},{"value":"th","name":"Th (+66)","position":"-3360","prefix":"+66"},{"value":"tn","name":"Tn (+216)","position":"-3440","prefix":"+216"},{"value":"tr","name":"Tr (+90)","position":"-3472","prefix":"+90"},{"value":"ug","name":"Ug (+256)","position":"-3568","prefix":"+256"},{"value":"uy","name":"Uy (+598)","position":"-3600","prefix":"+598"},{"value":"ph","name":"Ph (+63)","position":"-2768","prefix":"+63"},{"value":"fi","name":"Fi (+358)","position":"-1104","prefix":"+358"},{"value":"fr","name":"Fr (+33)","position":"-1184","prefix":"+33"},{"value":"td","name":"Td (+235)","position":"-3312","prefix":"+235"},{"value":"cz","name":"Cz (+420)","position":"-864","prefix":"+420"},{"value":"cl","name":"Cl (+56)","position":"-704","prefix":"+56"},{"value":"ch","name":"Ch (+41)","position":"-656","prefix":"+41"},{"value":"se","name":"Se (+46)","position":"-3056","prefix":"+46"},{"value":"lk","name":"Lk (+94)","position":"-2016","prefix":"+94"},{"value":"ec","name":"Ec (+593)","position":"-976","prefix":"+593"},{"value":"et","name":"Et (+251)","position":"-1072","prefix":"+251"},{"value":"za","name":"Za (+27)","position":"-3808","prefix":"+27"},{"value":"rs","name":"Rs (+381)","position":"-2944","prefix":"+381"},{"value":"jm","name":"Jm (+1)","position":"-1728","prefix":"+1"},{"value":"jp","name":"Jp (+81)","position":"-1760","prefix":"+81"},{"value":"bh","name":"Bh (+973)","position":"-368","prefix":"+973"},{"value":"ad","name":"Ad (+376)","position":"0","prefix":"+376"},{"value":"bz","name":"Bz (+501)","position":"-560","prefix":"+501"},{"value":"bt","name":"Bt (+975)","position":"-512","prefix":"+975"},{"value":"bw","name":"Bw (+267)","position":"-528","prefix":"+267"},{"value":"bi","name":"Bi (+257)","position":"-384","prefix":"+257"},{"value":"km","name":"Km (+269)","position":"-1840","prefix":"+269"},{"value":"ci","name":"Ci (+225)","position":"-672","prefix":"+225"},{"value":"dj","name":"Dj (+253)","position":"-896","prefix":"+253"},{"value":"er","name":"Er (+291)","position":"-1040","prefix":"+291"},{"value":"fj","name":"Fj (+679)","position":"-1120","prefix":"+679"},{"value":"ga","name":"Ga (+241)","position":"-1200","prefix":"+241"},{"value":"gh","name":"Gh (+233)","position":"-1280","prefix":"+233"},{"value":"gw","name":"Gw (+245)","position":"-1440","prefix":"+245"},{"value":"lb","name":"Lb (+961)","position":"-1968","prefix":"+961"},{"value":"ls","name":"Ls (+266)","position":"-2048","prefix":"+266"},{"value":"ly","name":"Ly (+218)","position":"-2112","prefix":"+218"},{"value":"mv","name":"Mv (+960)","position":"-2416","prefix":"+960"},{"value":"ne","name":"Ne (+227)","position":"-2528","prefix":"+227"},{"value":"om","name":"Om (+968)","position":"-2688","prefix":"+968"},{"value":"qa","name":"Qa (+974)","position":"-2912","prefix":"+974"},{"value":"rw","name":"Rw (+250)","position":"-2976","prefix":"+250"},{"value":"ws","name":"Ws (+685)","position":"-3760","prefix":"+685"},{"value":"sc","name":"Sc (+248)","position":"-3024","prefix":"+248"},{"value":"sl","name":"Sl (+232)","position":"-3136","prefix":"+232"},{"value":"sr","name":"Sr (+597)","position":"-3200","prefix":"+597"},{"value":"sz","name":"Sz (+268)","position":"-3280","prefix":"+268"},{"value":"tz","name":"Tz (+255)","position":"-3536","prefix":"+255"},{"value":"hr","name":"Hr (+385)","position":"-1504","prefix":"+385"},{"value":"ai","name":"Ai (+1)","position":"-64","prefix":"+1"},{"value":"mm","name":"Mm (+95)","position":"-2272","prefix":"+95"},{"value":"cv","name":"Cv (+238)","position":"-800","prefix":"+238"},{"value":"dm","name":"Dm (+1)","position":"-928","prefix":"+1"},{"value":"gf","name":"Gf (+594)","position":"","prefix":"+594"},{"value":"ki","name":"Ki (+686)","position":"-1824","prefix":"+686"},{"value":"la","name":"La (+856)","position":"-1952","prefix":"+856"},{"value":"mo","name":"Mo (+853)","position":"-2304","prefix":"+853"},{"value":"mw","name":"Mw (+265)","position":"-2432","prefix":"+265"},{"value":"mq","name":"Mq (+596)","position":"-2336","prefix":"+596"},{"value":"mu","name":"Mu (+230)","position":"-2400","prefix":"+230"},{"value":"yt","name":"Yt (+262)","position":"-3792","prefix":"+262"},{"value":"fm","name":"Fm (+691)","position":"-1152","prefix":"+691"},{"value":"ms","name":"Ms (+1)","position":"-2368","prefix":"+1"},{"value":"nr","name":"Nr (+674)","position":"-2640","prefix":"+674"},{"value":"nu","name":"Nu (+683)","position":"-2656","prefix":"+683"},{"value":"pw","name":"Pw (+680)","position":"-2880","prefix":"+680"},{"value":"ps","name":"Ps (+970)","position":"-2848","prefix":"+970"},{"value":"re","name":"Re (+262)","position":"","prefix":"+262"},{"value":"lc","name":"Lc (+1)","position":"-1984","prefix":"+1"},{"value":"sm","name":"Sm (+378)","position":"-3152","prefix":"+378"},{"value":"tg","name":"Tg (+228)","position":"-3344","prefix":"+228"},{"value":"tk","name":"Tk (+690)","position":"-3392","prefix":"+690"},{"value":"to","name":"To (+676)","position":"-3456","prefix":"+676"},{"value":"tv","name":"Tv (+688)","position":"-3504","prefix":"+688"},{"value":"vu","name":"Vu (+678)","position":"-3728","prefix":"+678"},{"value":"va","name":"Va (+39)","position":"-3632","prefix":"+39"},{"value":"me","name":"Me (+382)","position":"-2176","prefix":"+382"}],
        phone:"",
        name:"",
        buttonActive:true,
        lastName:"",
        secondName:"",
        dialog:false,
    }),
  }
</script>

<style>
  .numberIcon .v-input__prepend-inner{
    width: 80px;
    margin:0;
    align-self: center;
  }

  .numberIcon .v-input__prepend-inner .v-label{
    top: 2px;
  }

</style>
